import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import SliderWrapper from 'jd-library/SliderWrapper';
import SliderHeader from 'jd-library/SliderHeader';
import ProductList from '../../common/product-list/ProductList'
import { useHistory } from 'react-router-dom';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';
import {
	getListingData,
	getVendorProducts
} from '../../actions/products'
import './select-product.scss'
import NoProductFound from '../../common/no-product-found/NoProductFound';
import Loader from 'jd-library/Loader';
import historyHandler from 'jd-library/historyHandler';

const SelectProductSlider = (props) => {
	let products = props.productList.results;
	const history = useHistory();
	const [scrollContainer, setScrollContainer] = useState(null);
	const [showLoader, setshowLoader] = useState(false);

	console.log(scrollContainer);

	useEffect(() => {
		if (props.session.source == 'webstore') {
			props.getVendorProducts({
				pageNo: 1,
				orderBy: "image",
				isSelectProdSlider: true
			}).then(() => {
				setIsFetching(false);
			});
		}else{
			setshowLoader(true);
			props
				.getListingData({
					pageNo: 1,
					orderBy: "image",
					isSelectProdSlider: true,
					// tabKey: props.tabKey,
					cb:()=>{
						setshowLoader(false);
					}
				})
				.then(res => {
					setIsFetching(false);
				});
		}
	}, [])

	const loadDataOnInfiniteScroll = () => {
		if (props.productList.allResultsFetched) {
			setIsFetching(false);
			return;
		}
		const pageNo = props.productList.currentPage + 1;
		if (props.session.source == 'webstore') {
			props.getVendorProducts({
				pageNo,
				orderBy: "image",
				isSelectProdSlider: true
			}).then(() => {
				setIsFetching(false);
			});
		}else{
			props
				.getListingData({
					pageNo,
					orderBy: "image",
					isSelectProdSlider: true,
					// tabKey: props.tabKey
				})
				.then(res => {
					setIsFetching(false);
				});
		}
	};

	const [isFetching, setIsFetching] = useInfiniteScroll({
		loadMoreCB: loadDataOnInfiniteScroll,
		scrollContainer: scrollContainer,
		threshold: 300,
		deps: [scrollContainer]
	});
	const sliderHeading = `Select ${props.session.profileObject.SingleLabelWithSpace} to Add Photos`;
	const noProductLabel = `No ${props.session.profileObject?.PluralLabelWithSpace} Found`;
	return (
		<SliderWrapper
			avoidPortal
			onHidden={() => props.onHidden()}
			slider={{
				className: props.isMobile ? 'selected-prod' : 'selected-prod web-page'
			}}
			updateScrollContRef={setScrollContainer}
			header={{
				heading:props.isMobile ? sliderHeading : <span className='font-16'>{sliderHeading}</span>,
				leftIcons: [
					{
						className: props.session.source == 'webstore' ? 'icon-HDRback' : 'icon-hdrBackNew',
						onClick: () => {
							props.getListingData({ 
								tabKey: props.tabKey, 
								cb:(res) => {
									if(res){
										historyHandler.closeCurrent();
									}
								}
							})
						}
					}
				],
				rightIcons: [
					{
						className: 'icon-HDRsearch',
						onClick: () => {
							props.onSearchIconClick();
						}
					}
				],
				hasBorder: true
			}}
			enableHeader
		>
			{ showLoader ?
				<div className="loader-holder">
					<Loader
						style ={{borderColor: "#3B74A9", borderTopColor: "white", height: "1.25rem", width: "1.25rem"}}
					/>
				</div>
				:
				products?.length > 0 ?
					<ProductList
						{...props}
						onProductClick={(productData) => {
							props.onSelectProduct(productData)
						}}
						onlyForSelection
						readOnlyProduct
						fromSelectProductSlider={true}
						products={products}
					/>
				: <NoProductFound label={noProductLabel}/> }
		</SliderWrapper>
	)
}

const mapStateToProps = (state, props) => {
	return {
		...props,
		productList: state.products.productList,
		session: state.session,
		tabKey:state.products.tabKey,
		isMobile:state.library.deviceData.isMobile,
		showLibrarySlider: state.videoLibrary.showLibrarySlider,
		approvalPendingList: state.products.approvalPendingList,
		deletionPendingList: state.products.deletionPendingList,
		allProducts: state.products.allProducts,
		confirmDeleteModal: state.products.confirmDeleteModal,
		isToggleTab: state.products.isToggleTab,
		showInfoBox: state.products.showInfoBox,
		isSearchSliderOpen: state.products.isSearchSliderOpen,
		redirectedFrom: state.products.redirectedFrom
	};
}

export default connect(mapStateToProps, {
	getVendorProducts,
	getListingData
})(SelectProductSlider)